import { MessageBarType } from '@fluentui/react';
import { orchestrator } from 'satcheljs';
import { getAppStore, onLoadingChanged, onNotificationChanged } from '../../../../@data';
import { NewReportRoute, RoutePrefix } from '../../../../Routes';
import messages from '../../Report.messages';
import { onNewReportClicked } from '../actions';
import { RouteName } from '../store/store';

orchestrator(onNewReportClicked, () => {
  const { publisher, userContext } = getAppStore();

  if (publisher && publisher.id && userContext) {
    onLoadingChanged(true);
    try {
      window.open(`${window.location.origin}/${RoutePrefix.report}${NewReportRoute}/${publisher.id}/${RouteName[RouteName.overview]}`);
    } catch (e) {
      onNotificationChanged({
        textMessageDescriptor: messages.reportsNotAvailableAtThisTime,
        messageBarType: MessageBarType.severeWarning,
      });
    } finally {
      onLoadingChanged(false);
    }
  } else {
    onNotificationChanged({
      textMessageDescriptor: messages.reportInvalidState,
      messageBarType: MessageBarType.severeWarning,
    });
  }
});
